import React, {
  SelectHTMLAttributes,
  useEffect,
  useRef,
  useState,
  useCallback,
} from 'react';
import { Flex } from '@chakra-ui/react';
import { IconBaseProps } from 'react-icons';
import { useField } from '@unform/core';
import { FiAlertCircle } from 'react-icons/fi';

import { Container, Error } from './styles';

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  icon?: React.ComponentType<IconBaseProps>;
  containerStyle?: object;
  options: OptionsData[];
  placeholder: string;
}
interface OptionsData {
  id: number;
  sub_classif: string;
}

const InputSelectClassif: React.FC<SelectProps> = ({
  name,
  icon: Icon,
  options,
  placeholder,
  containerStyle,
  ...rest
}) => {
  const inputRef = useRef<HTMLSelectElement>(null);
	const iconRef = useRef<any>(null);

  const [isFocused, setIsFocused] = useState(false);
  const [isField, setIsField] = useState(false);
  const { fieldName, defaultValue, error, registerField } = useField(name);
	const [isEmpt, setIsEmpt] = useState(true);

  const handleInputFocus = useCallback(() => {
    setIsFocused(true);
  }, []);

  const handleInputBlur = useCallback(() => {
    setIsFocused(false);
    setIsField(!!inputRef.current?.value);
  }, []);

	const handleChange = useCallback(() => {
		if (
			!inputRef.current?.value ||
			inputRef.current?.value === undefined ||
			inputRef.current?.value === null ||
			inputRef.current?.value === ''
		) {
			setIsEmpt(true);
		} else {
			setIsEmpt(false);
		}
	}, []);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  return (
    <Container
      isErrored={!!error}
      isField={isField}
      isFocused={isFocused}
      style={containerStyle}
			isEmpt={isEmpt}
    >
      {Icon && <Icon size={20} />}
      <select
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
				onChange={handleChange}
        defaultValue={defaultValue}
        ref={inputRef}
        {...rest}
      >
        <option value="" disabled>
          {placeholder}
        </option>

        {options.map((item, indice) => (
          <option key={indice} value={item.id}>
            {item.sub_classif}
          </option>
        ))}
      </select>

      {error && (
				<Error title={error}>
					<Flex pr={1} ref={iconRef}>
						<FiAlertCircle color="#c53030" size={20} />
					</Flex>
				</Error>
      )}
    </Container>
  );
};

export default InputSelectClassif;
